// @flow
import moment from 'moment';

import fetch from 'utils/fetch';
import { formatMinutesAsTime } from 'utils/datetime';
import { toggleSearchResultsDialog } from 'actions/searchResultsDialog';

export const CONTACT_CARD_RESET_STATE = 'contactCard/RESET_STATE';
export const CONTACT_CARD_SET_ERROR = 'contactCard/SET_ERROR';
export const CONTACT_CARD_SET_FIELDS = 'contactCard/SET_FIELDS';
export const CONTACT_CARD_SET_FORM_STATE = 'contactCard/SET_FORM_STATE';

export function resetState() {
  return {
    type: CONTACT_CARD_RESET_STATE,
  };
}

export function setFormState(formState) {
  return {
    type: CONTACT_CARD_SET_FORM_STATE,
    formState,
  };
}

export function setContactFields(fields) {
  return (dispatch, getState) =>
    dispatch({
      type: CONTACT_CARD_SET_FIELDS,
      fields: {
        ...getState().contactCard.fields,
        ...fields,
      },
    });
}

export function submitContactData(recaptchaResponse) {
  return (dispatch, getState) => {
    const {
      contactCard: {
        fields: { name, email, phone, startDate, endDate, tosAccepted, notRobot },
      },
      search: { slug },
    } = getState();

    dispatch(setFormState('sending'));

    fetch(`/api/v1/s/${slug}/update_contact_info`, {
      method: 'POST',
      body: JSON.stringify({
        slug,
        contact_info: {
          name,
          email,
          phone,
          startDate: startDate ? startDate.format('YYYY-MM-DD') : null,
          endDate: endDate ? endDate.format('YYYY-MM-DD') : null,
        },
        recaptcha_response: recaptchaResponse,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          dispatch(setFormState('sent'));
        }
      });
  };
}



// WEBPACK FOOTER //
// ./actions/contactCard.js